exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.cart-card .table {\n  margin-bottom: 0;\n}\n.btn-submit-order {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n.product-price {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b134504a","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/CheckoutConfirmationModal.vue
// module id = Eqow
// module chunks = 14